const teamContextReducer = (state, action) => {
    return action.payload.currentTeams ?? {
        teamId: null,
    };
};

export { teamContextReducer };
